module.exports = __webpack_public_path__ + "static/media/Test7.623825c2.bmp";